const languageData = [
	{
		languageId: 'english',
		locale: 'en',
		name: 'English',
		icon: 'us',
	},
];
export default languageData;
